import PropTypes from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components/macro";

import { Input, Label } from "./Styles";

export const ZipField = forwardRef(function ZipField(
  {
    value = "",
    onChange,
    onBlur,
    labelOverride,
    name = "zip",
    placeholder,
    countryIDOrCode,
    hideInternalFocusStyles = false,
    autoComplete,
    style,
    disabled,
  },
  ref
) {
  let label = "Postal";
  if (typeof labelOverride === "string" && labelOverride.length > 0) {
    label = labelOverride;
  } else if (countryIDOrCode === 1 || countryIDOrCode === "US") {
    label = "Zip";
  }

  return (
    <Wrapper style={style}>
      {name ? <Label htmlFor={name}>{label}</Label> : null}
      <Input
        ref={ref}
        data-cy="fnrAddressZipField"
        id={name}
        name={name}
        placeholder={placeholder ?? label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        hideInternalFocusStyles={hideInternalFocusStyles}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </Wrapper>
  );
});

ZipField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  labelOverride: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  countryIDOrCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hideInternalFocusStyles: PropTypes.bool,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 6px;
`;
